// Localization services we offer — used in Portfolio show editor
export const SERVICE_CATEGORIES = [
  {
    category: "Subtitle Translation",
    services: [
      "Subtitle Translation (75+ Languages)",
      "Localization for OTT Platforms",
      "Cultural Adaptation & Localization",
      "Multi-Language Subtitle Delivery",
    ],
  },
  {
    category: "English Master Template (EMT) Creation",
    services: [
      "EMT Creation from STT/ASR Transcripts",
      "EMT Creation from Client Scripts",
      "EMT Creation from Existing Subtitle Files",
      "Foreign Spotting & Template Creation",
      "Forced Narrative (FN) Template Creation",
    ],
  },
  {
    category: "Subtitle Timing & Spotting",
    services: [
      "Subtitle Cueing & Spotting",
      "Empty Spot Timecoding",
      "Shot Change Compliance",
      "Dialogue Synchronization",
      "Subtitle Segmentation & Line Breaking",
    ],
  },
  {
    category: "Subtitle Conforming & Reformatting",
    services: [
      "Simple Conform",
      "Complex Conform",
      "Subtitle Retiming",
      "Subtitle Resynchronization",
      "Version Matching & Re-Conforming",
    ],
  },
  {
    category: "Quality Control Services",
    services: [
      "Linguistic QC",
      "Technical QC",
      "Subtitle Review & Validation",
      "Reading Speed Optimization",
      "CPL/CPS Compliance Checks",
      "Client Guideline Compliance",
      "OTT Delivery Readiness Checks",
    ],
  },
  {
    category: "Accessibility Services",
    services: [
      "Closed Caption (CC) Creation",
      "SDH Template Creation",
      "Accessibility Compliance Review",
      "Speaker Identification & Sound Effects Captioning",
    ],
  },
  {
    category: "Dubbing Localization Support",
    services: [
      "Dubbing Script Translation",
      "Dub Script Adaptation",
      "Dub-to-Sub Conversion",
      "Dialogue List Creation",
      "KNP (Key Names & Places) Management",
    ],
  },
];

export const ALL_SERVICES = SERVICE_CATEGORIES.flatMap((c) => c.services);
